import React, { memo } from 'react';
import { Grid, TextField, Select, MenuItem, IconButton, Tooltip, FormControl, InputAdornment, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import InputMask from "react-input-mask";
import { FileDownloadSharp } from '@mui/icons-material';

export const RowIIBB = memo(({ 
    field, 
    index, 
    totalRows, 
    provincias, 
    configConvenio, 
    columnSizes, 
    inputsx, 
    inputProps, 
    handleInputChange, 
    deshacerAlmacenar, 
    almacenarImpuesto ,
    isOptionDisabled,
    handleInputChangeProvincia
}) => {

    const rowKey = field.tempId;

    return (
        <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            p={1}
            backgroundColor="#fff"
            mt={1}
            borderRadius={1}
            direction="row"
        >
            <Grid item xs={columnSizes.provincia} sx={{ display: "flex", alignItems: "center" }}>
                <LocationOnIcon color="primary" />
                <FormControl fullWidth>
                    <Select
                        disabled={!!field.id_provincia}
                        variant="filled"
                        size="small"
                        value={field.id_provincia}
                        // onChange={(e) => handleInputChange(rowKey, e)}
                        onChange={(e)=>handleInputChangeProvincia(rowKey, e)}
                        name="id_provincia"
                        sx={{ ...inputsx, height: "32px" }}
                    >
                        {provincias.map((provincia) => {
                          return (
                            <MenuItem 
                              key={provincia.id} 
                              value={provincia.id}
                              disabled={isOptionDisabled(provincia)}
                            >
                                {provincia.cod_ddjj} - {provincia.provincia} {provincia.iibb_auto === 1 ? "(Padrón)" : ""}
                            </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Grid>

            {configConvenio?.evalua_coeficiente_cm05 == 1 && (
                <Grid item xs={columnSizes.coeficienteUnificado}>
                    <InputMask
                        mask="9.9999"
                        value={field.coeficiente_unificado || "0.0000"}
                        maskChar="0"
                        onChange={(e) => handleInputChange(rowKey, e)}
                    >
                        {() => (
                            <TextField variant="filled" size="small" fullWidth name="coeficiente_unificado" InputProps={inputProps} sx={inputsx} />
                        )}
                    </InputMask>
                </Grid>
            )}

            <Grid item xs={columnSizes.percepcion}>
                <InputMask
                    disabled={Boolean(field?.iibb_auto) || Boolean(field?.percepcion_fija) || field?.deshabilitaPercepcion}
                    mask="9.99"
                    value={field?.percepcion || "0.00"} 
                    maskChar="0"
                    onChange={(e) => handleInputChange(rowKey, e)}
                >
                    {() => (
                        <TextField 
                        disabled={Boolean(field?.iibb_auto) || Boolean(field?.percepcion_fija) || field?.deshabilitaPercepcion}
                        variant="filled" 
                        size="small" 
                        fullWidth 
                        name="percepcion" 
                        InputProps={inputProps} 
                        sx={inputsx} />
                    )}
                </InputMask>
            </Grid>

            <Grid item xs={columnSizes.exencion}>
                <TextField
                    value={field.porcentaje_excencion || ""}
                    onChange={(e) => handleInputChange(rowKey, e)}
                    variant="filled"
                    size="small"
                    fullWidth
                    name="porcentaje_excencion"
                    sx={inputsx}
                />
            </Grid>

            <Grid item xs={columnSizes.vtoExencion}>
                <TextField
                    variant="filled"
                    size="small"
                    fullWidth
                    type="date"
                    name="vto_excencion"
                    value={field.vto_excencion || ""}
                    onChange={(e) => handleInputChange(rowKey, e)}
                    InputProps={inputProps}
                    sx={inputsx}
                />
            </Grid>

            <Grid item xs={columnSizes.acciones} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 3 }}>
                <Tooltip title="Eliminar IIBB">
                    <IconButton onClick={() => deshacerAlmacenar(field)} color="error" sx={{ p: 0.5 }}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
                {index === totalRows - 1 && (
                    <Tooltip title="Agregar IIBB">
                        <IconButton
                            disabled={configConvenio?.max_inscripciones && totalRows >= configConvenio.max_inscripciones}
                            onClick={() => almacenarImpuesto()}
                            color="success"
                            sx={{ p: 0.5 }}
                        >
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </Grid>
        </Grid>
    );
});